import { Component, computed, effect, inject, signal, viewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VatutorChatComponent } from '../features/vatutor-chat/vatutor-chat.component';
import { AuthService } from '../services/auth.service';
import { InsegnamentoService, InsegnamentoItem } from '../common/services/insegnamento.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { lastValueFrom } from 'rxjs';
import { CustomHeaderComponent } from '../common/components/custom-header/custom-header.component';
import { EkButtonComponent } from '@beta-foundations/ui-kit/buttons';


@Component({
  selector: 'app-test-chat',
  standalone: true,
    imports: [
        VatutorChatComponent,
        CustomHeaderComponent,
        EkButtonComponent
    ],
  templateUrl: './test-chat.component.html',
  styleUrl: './test-chat.component.scss',
})
export class TestChatComponent {

  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly insegnamentoService = inject(InsegnamentoService);
  widget = viewChild<VatutorChatComponent>('chat');
  accessType = computed(() => this.route.snapshot.routeConfig?.path?.includes('private') ? 'private' : 'public');
  chatType = computed(() => this.route.snapshot.params?.['type'] || 'widget');
  isStandalone = computed(() => this.chatType() === 'standalone');
  
  private routerState = this.route.snapshot.paramMap.keys.length > 0 
    ? (window.history.state as any) 
    : {};
  
  saveAs = computed(() => this.routerState?.saveAs || null);
  autoOpen = computed(() => this.routerState?.autoOpen === true);
  useGenerateEndpoint = computed(() => this.routerState?.useGenerateEndpoint === true);
  
  shouldStartClosed = computed(() => this.useGenerateEndpoint());
  dialogMode = computed(() => this.useGenerateEndpoint() && this.autoOpen());
  accessToken = signal<string | null>(null);
  chatIntro = signal<string>('');
  loaded = signal(false);

  courseId = signal<string | null>(null);
  subTenantName = signal<string | null>(null);

  constructor() {
    this.insegnamentoService.selectedTeaching$
      .pipe(takeUntilDestroyed())
      .subscribe((selected: InsegnamentoItem | null) => {
        this.courseId.set(selected ? String(selected.id) : null);
        this.subTenantName.set(selected?.insegnamento ?? null);
      });

    effect(async () => {
      try {
        if (this.accessType() === 'private') {
          const accessToken = await this.authService.getAccessToken();
          const user = await lastValueFrom(this.authService.getUserInfo());
          this.accessToken.set(accessToken);
          this.chatIntro.set(`Name: ${user?.name}`);
          this.loaded.set(true);
        } else if (this.accessType() === 'public') {
          this.accessToken.set(null);
          this.loaded.set(true);
        }
      } catch (error) {
        console.error(error);
      }
    }, {
      allowSignalWrites: true,
    });
  }

  showFeedback() {
      this.widget()?.showFeedback();
  }
}
